import React from 'react';

/**
 * RegionalAssessmentTabs component for displaying assessment templates by region
 * @param {Object} props - Component props
 * @param {string} props.activeTab - Currently active tab (all, uk, eu, aus, dora)
 * @param {Function} props.setActiveTab - Function to set active tab
 * @param {Object} props.styles - Styles object for consistent styling
 */
const RegionalAssessmentTabs = ({ activeTab, setActiveTab, styles }) => {
  return (
    <div style={styles.tabs}>
      <button 
        type="button"
        style={{
          ...styles.tabButton,
          ...(activeTab === 'recommended' ? styles.activeTabButton : {})
        }}
        onClick={() => setActiveTab('recommended')}
      >
        Recommended
      </button>
      <button 
        type="button"
        style={{
          ...styles.tabButton,
          ...(activeTab === 'all' ? styles.activeTabButton : {})
        }}
        onClick={() => setActiveTab('all')}
      >
        All Assessments
      </button>
      <button 
        type="button"
        style={{
          ...styles.tabButton,
          ...(activeTab === 'uk' ? styles.activeTabButton : {})
        }}
        onClick={() => setActiveTab('uk')}
      >
        UK
      </button>
      <button 
        type="button"
        style={{
          ...styles.tabButton,
          ...(activeTab === 'eu' ? styles.activeTabButton : {})
        }}
        onClick={() => setActiveTab('eu')}
      >
        EU
      </button>
      <button 
        type="button"
        style={{
          ...styles.tabButton,
          ...(activeTab === 'aus' ? styles.activeTabButton : {})
        }}
        onClick={() => setActiveTab('aus')}
      >
        Australia
      </button>
      <button 
        type="button"
        style={{
          ...styles.tabButton,
          ...(activeTab === 'dora' ? styles.activeTabButton : {})
        }}
        onClick={() => setActiveTab('dora')}
      >
        DORA
      </button>
    </div>
  );
};

export default RegionalAssessmentTabs;
